/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import e from "react";
import { classNames as c } from "@progress/kendo-react-common";
const o = "ActionSheetView", s = e.forwardRef((t, a) => {
  const i = e.useRef(null);
  return e.useImperativeHandle(a, () => i, []), /* @__PURE__ */ e.createElement("div", { ref: i, style: t.style, className: c("k-actionsheet-view", t.className) }, t.children);
});
s.displayName = "ActionSheetView";
export {
  s as ActionSheetView,
  o as ActionSheetViewDisplayName
};
